import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmUploadDialogData {
  fileName: string;
  fileSize: string;
}

@Component({
  selector: 'izy-confirm-upload-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
  ],
  templateUrl: './confirm-upload-dialog.component.html',
  styleUrl: './confirm-upload-dialog.component.scss',
})
export class ConfirmUploadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmUploadDialogData,
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }
}
